<div class="row" *transloco="let t; read: TRANSLATION_SCOPE">
  <div class="col pb-2">
    <h5>{{ t('label.room') }} {{ index + 1 }}</h5>
    <span>
      {{ room.adults }}
      {{ room.adults > 1 ? t('label.pluralAdult') : t('label.singleAdult') }}, {{ room.name }} </span
    >&nbsp;<span *ngIf="room.meal">- {{ room.meal }}</span>
  </div>
</div>
